// extracted by mini-css-extract-plugin
export default {"input":"Legal_input__+iCUq"};